import React from 'react';
import './PageTitle.css';

const PageTitle = ({ title, subtitle }) => {
  return (
    <div className="page-title">
      <h1>{title}</h1>
      {subtitle && <p className="subtitle">{subtitle}</p>}
    </div>
  );
};

export default PageTitle;
